import { lazy } from 'react'
import { Bot, Building2, Home, Moon, UserSearch } from 'lucide-react'

/**
 * Bases du CRM : les résultats de toutes les recherches (et les projets auto pour USTS).
 * `group` : entrée du menu qui les affiche — « clients » (Clients) ou « projets » (Projets auto).
 * `module` : droit nécessaire (features/access/modules.js) ; sans `module`, visible par tous.
 * Les écrans sont chargés à la demande : chaque base est un écran complet existant.
 */
export const CRM_BASES = [
  {
    key: 'prospects',
    group: 'clients',
    label: 'Prospects B2B',
    icon: Building2,
    module: 'prospects',
    component: lazy(() => import('../../pages/MyProspects.jsx')),
  },
  {
    key: 'immobilier',
    group: 'clients',
    label: 'Biens immobiliers',
    icon: Home,
    module: 'immobilier',
    component: lazy(() => import('./components/ImmobilierAcquired.jsx')),
  },
  {
    key: 'candidats-ft',
    group: 'clients',
    label: 'Candidats France Travail',
    icon: UserSearch,
    module: 'france_travail',
    component: lazy(() => import('../france-travail-candidates/pages/FranceTravailCandidatesPage.jsx')),
  },
  {
    key: 'projets-auto',
    group: 'projets',
    label: 'Projets auto',
    icon: Bot,
    module: 'projects_auto',
    component: lazy(() => import('../../pages/ProjectsAuto.jsx')),
  },
  {
    key: 'relances',
    group: 'projets',
    label: 'Relances',
    icon: Moon,
    component: lazy(() => import('../../pages/DormantProjects.jsx')),
  },
]

/** Adresse d'une base : /dashboard/clients/<base> ou /dashboard/projets-auto/<base>. */
export const CRM_GROUP_PATHS = { clients: '/dashboard/clients', projets: '/dashboard/projets-auto' }
export const crmBasePath = (base) => `${CRM_GROUP_PATHS[base.group]}/${base.key}`
